import { Badge, EmptyState, StoreCard } from '@beautyburst/ui';
import { AVAILABILITY_LABEL_TEXT } from '@beautyburst/types';
import { semanticColor, space, typeStyle } from '@beautyburst/tokens';
import { customerHref } from '../base-path.ts';
import type { NearbyStore } from './stores.tsx';

export function AfterHoursScreen({ stores }: { stores: readonly NearbyStore[] }) {
  return (
    <section aria-labelledby="after-hours-heading" style={{ display: 'grid', gap: space[5] }}>
      <h1
        id="after-hours-heading"
        style={{ ...typeStyle('headingLg'), color: semanticColor.textPrimary, margin: 0 }}
      >
        Beauty After Hours
      </h1>
      <p style={{ margin: 0 }}>Availability is shown only when the service has confirmed it.</p>
      {stores.length === 0 ? (
        <section aria-labelledby="after-hours-status-title">
          <h2 id="after-hours-status-title" style={typeStyle('headingSm')}>
            After-hours availability
          </h2>
          <EmptyState
            title="No after-hours options are confirmed"
            description="Availability may change; we will only show items the service has confirmed."
            action={<a href={customerHref('/stores')}>Browse available stores</a>}
          />
        </section>
      ) : (
        <ul
          aria-label="After-hours stores"
          style={{ display: 'grid', gap: space[3], listStyle: 'none', padding: 0 }}
        >
          {stores.map((store) => (
            <li key={store.slug}>
              <StoreCard
                href={customerHref(`/stores/${store.slug}`)}
                storeName={store.name}
                bannerUrl={null}
                tagline={store.tagline}
                averageRating={store.averageRating}
                reviewCount={store.reviewCount}
                distanceMiles={store.distanceMiles}
                pickupEnabled={store.pickupEnabled}
                deliveryEnabled={store.deliveryEnabled}
              />
              {store.availability === null ? null : (
                <Badge variant="info">{AVAILABILITY_LABEL_TEXT[store.availability.label]}</Badge>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
